<template>
  <img cdn-img :key="val" :src="val" :alt="description" @load="onImageLoad" :class="{ loading: !loaded }">
</template>

<script>
export default {
  name: 'CdnImg',
  data() {
    return {
      loaded: false,
    };
  },
  props: {
    filekey: { type: String, default: null },
    src: { type: String, default: null },
  },
  computed: {
    val() {
      return `${ this.cdnHost }/${ this.location }`;
    },
    location() {
      return this.mediaVal(this.src)?.location ?? '';
    },
    sq() {
      return this.mediaVal(this.src)?.sq ?? '';
    },
    description() {
      if (!this.$store.state.images) return '';
      return this.$store.state.images.find(row => row.sq === this.sq)?.description ?? '';
    },
  },
  watch: {
    src: {
      handler() {
        this.loaded = false; // 새 이미지 로딩 시작 시 초기화
      },
      deep: true,
      immediate: true,
    },
  },
  methods: {
    onImageLoad() {
      this.loaded = true;
    },
  },
};
</script>

<style lang="less">
@import '~@/less/proj.less';

[cdn-img] { .rel; .block; max-width: 100%;
  &.loading { visibility: hidden; }
}
</style>